import {
  Button,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Select,
  message
} from 'antd';
import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { createNewCoupon } from '../../../../api/pricing';

const NewCoupon = ({ setAddModal }) => {
  const [loading, setLoading] = useState(false);
  const [formInput, setFormInput] = useState({});
  const navigate = useNavigate();

  const handleChangeInput = (e) => {
    setFormInput({ ...formInput, [e.target.name]: e.target.value });
  };

  const handleCancel = () => {
    setFormInput({});
    setAddModal(false);
  };

  const handleNewCoupon = async () => {
    if (!formInput.code || !formInput.percent_off || !formInput.duration) {
      return;
    };
    setLoading(true);

    try {
      const payload = {
        code: formInput.code,
        percent_off: formInput.percent_off,
        duration: formInput.duration,
        max_redemptions: formInput?.max_redemptions || null,
        duration_in_months: formInput.duration_in_months || null,
        expires_at: formInput.expires_at || null,
      };

      const res = await createNewCoupon(payload);
      const data = res.data;
      if (data?.message) {
        message.success(data.message);
      };
      setFormInput({});
      setAddModal(false);
      navigate(0);
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Divider />
      <Form layout="vertical" className="form">
        <Form.Item
          label="Coupon Code"
          name="code"
          onChange={handleChangeInput}
          rules={[{ required: true, message: 'Coupon Code is required!' }]}
        >
          <Input name="code" />
        </Form.Item>

        <Form.Item
          label="Percentage Off"
          name="percent_off"
          onChange={handleChangeInput}
          rules={[{ required: true, message: 'Discount Percent is required!' }]}
        >
          <InputNumber name="percent_off" style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Max Number of Usage"
          onChange={handleChangeInput}
          name="max_redemptions"
          rules={[{ required: false, message: 'Max Number of Usage is required!' }]}
        >
          <InputNumber name="max_redemptions" style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          name="duration"
          label="Discount Type"
          rules={[{ required: true, message: 'Discount Type is required!' }]}
        >
          <Select
            onChange={(option) => setFormInput({ ...formInput, duration: option })}
            name="duration"
            options={['once', 'repeating', 'forever'].map((item) => ({
              label: item,
              value: item,
            }))}
          />
        </Form.Item>

        <Form.Item
          label="How many month applied?"
          name="duration_in_months"
          onChange={handleChangeInput}
          rules={[{
            required: formInput.duration === "repeating",
            message: 'Month is required!'
          }]}
        >
          <InputNumber
            disabled={formInput.duration !== "repeating"}
            name="duration_in_months"
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item
          label="Expire Date"
          name="expires_at"
          rules={[{ required: false, message: 'Please input!' }]}
        >
          <DatePicker
            onChange={(_, date) => setFormInput({ ...formInput, expires_at: date })}
            picker="date"
            style={{ width: '100%' }}
            name="expires_at"
          />
        </Form.Item>

        <div className="d-flex justify-content-end gap-2 mt-4 align-items-center">
          <Button onClick={handleCancel}>
            Cancel
          </Button>
          <Button loading={loading} disabled={loading} onClick={handleNewCoupon} type="primary">
            Create Coupon
          </Button>
        </div>
      </Form>
    </>
  );
};

export default NewCoupon;
